import React from 'react'
import { Icon, IconButton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';
import { toast } from 'react-toastify'
import TagDialog from './TagDialog'
import { DATASET_RULES_FIELD_NAME } from 'app/constants/datasets.constants';
import { QueryViewer } from 'app/views/pages/datasets/components/DatasetRulesBuilder/DatasetRulesBuilder';

const useStyles = makeStyles(({ palette, ...theme }) => ({
  tag: {
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
  },
}))

const FormTags = ({
  editable = true,
  values,
  setFieldValue,
  setFieldTouched,
  hideTitle,
  viewOnlyTags,
  VISUAL_TAGS_LABELS = {},
}) => {
  const classes = useStyles()

  const parseValue = (tagKey, tagValue) => {
    if(tagKey === DATASET_RULES_FIELD_NAME){
      let rules = [];
      try {
        rules = JSON.parse(tagValue) || []
      } catch (error) {
      }

      return <div>
        {rules.map((rule, index) => {
          return (<div key={"rule-" + index}><strong>{rule.ruleName}:</strong> <QueryViewer value={rule.value}/></div>)
        })}
      </div>
    }
    return Array.isArray(tagValue) ? tagValue.join(', ') : tagValue
  }

  return (
    <div>
      {!hideTitle && <h5 className="mt-2">Custom Properties</h5>}
      {editable && (
        <TagDialog
          isMaximumReached={values.tags.length >= 50}
          handleAddTag={(tag) => {
            const index = values.tags.findIndex((item) => item.key === tag.key)
            if (index === -1) {
              setFieldTouched && setFieldTouched('tags', true)
              setFieldValue('tags', values.tags.concat(tag))
            } else {
              toast.error('This tag already exists.')
            }
          }}
        />
      )}
      {viewOnlyTags &&
        viewOnlyTags.map((tag, index) => {
          return (
            <div  key={`view-${index}-${tag.key}`} className={'flex py-2 px-2 mb-1 ' + classes.tag}>
              <span>
                <strong>{VISUAL_TAGS_LABELS[tag.key] || tag.key}:</strong> {parseValue(tag.key, tag.value)}
              </span>
            </div>
          )
        })}
      {values.tags &&
        values.tags.map((tag, index) => {
          return (
            <div
              key={`${index}-${tag.key}`}
              className={
                'flex justify-between items-center py-1 px-2 mb-1 ' +
                classes.tag
              }
            >
              <div>
                <span>
                  <strong>{VISUAL_TAGS_LABELS[tag.key] || tag.key}:</strong> {parseValue(tag.key, tag.value)}
                </span>
              </div>
              <div>
                {editable && (
                  <IconButton
                    size="small"
                    className="text-error"
                    onClick={() => {
                      values.tags.splice(index, 1)
                      setFieldTouched && setFieldTouched('tags', true)
                      setFieldValue('tags', values.tags)
                    }}
                  >
                    <Icon fontSize="small">delete</Icon>
                  </IconButton>
                )}
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default FormTags
